import { Button, Col, Form, Row } from 'react-bootstrap'
import * as Yup from 'yup'

type Values = {
  fullWidthYear: boolean
  fullWidthMonth: boolean
  fullWidthDay: boolean
  fullWidthWareki: boolean
  fullWidthIssue: boolean
  fullWidthRevision: boolean
  fullWidthOther: boolean
}

type Props = {
  values: Values
  errors: Partial<Record<keyof Values, string>>
  touched: Partial<Record<keyof Values, boolean>>
  handleChange: React.ChangeEventHandler<HTMLElement>
  handleBlur: React.FocusEventHandler<HTMLElement>
  handleSubmit: React.SubmitEventHandler<HTMLFormElement>
  isValid: boolean
  isSettingWritable: boolean
}

const _MarginOutputSettingForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  isValid,
  isSettingWritable
}: Props) => {
  return (
    <Form noValidate onSubmit={handleSubmit}>
      <Form.Check
        type='switch'
        id='fullWidthYearSwitch'
        label='年・全角'
        name='fullWidthYear'
        value={String(values.fullWidthYear)}
        checked={values.fullWidthYear}
        onChange={handleChange}
        onBlur={handleBlur}
        isInvalid={!!(touched.fullWidthYear && errors.fullWidthYear)}
        disabled={!isSettingWritable}
      />
      <Form.Check
        type='switch'
        id='fullWidthMonthSwitch'
        label='月・全角'
        name='fullWidthMonth'
        value={String(values.fullWidthMonth)}
        checked={values.fullWidthMonth}
        onChange={handleChange}
        onBlur={handleBlur}
        isInvalid={!!(touched.fullWidthMonth && errors.fullWidthMonth)}
        disabled={!isSettingWritable}
      />
      <Form.Check
        type='switch'
        id='fullWidthDaySwitch'
        label='日・全角'
        name='fullWidthDay'
        value={String(values.fullWidthDay)}
        checked={values.fullWidthDay}
        onChange={handleChange}
        onBlur={handleBlur}
        isInvalid={!!(touched.fullWidthDay && errors.fullWidthDay)}
        disabled={!isSettingWritable}
      />
      <Form.Check
        type='switch'
        id='fullWidthWarekiSwitch'
        label='和暦・全角'
        name='fullWidthWareki'
        value={String(values.fullWidthWareki)}
        checked={values.fullWidthWareki}
        onChange={handleChange}
        onBlur={handleBlur}
        isInvalid={!!(touched.fullWidthWareki && errors.fullWidthWareki)}
        disabled={!isSettingWritable}
      />
      <Form.Check
        type='switch'
        id='fullWidthIssueSwitch'
        label='号・全角'
        name='fullWidthIssue'
        value={String(values.fullWidthIssue)}
        checked={values.fullWidthIssue}
        onChange={handleChange}
        onBlur={handleBlur}
        isInvalid={!!(touched.fullWidthIssue && errors.fullWidthIssue)}
        disabled={!isSettingWritable}
      />
      <Form.Check
        type='switch'
        id='fullWidthRevisionSwitch'
        label='版・全角'
        name='fullWidthRevision'
        value={String(values.fullWidthRevision)}
        checked={values.fullWidthRevision}
        onChange={handleChange}
        onBlur={handleBlur}
        isInvalid={!!(touched.fullWidthRevision && errors.fullWidthRevision)}
        disabled={!isSettingWritable}
      />
      <Form.Check
        type='switch'
        id='fullWidthOtherSwitch'
        label='他・全角'
        name='fullWidthOther'
        value={String(values.fullWidthOther)}
        checked={values.fullWidthOther}
        onChange={handleChange}
        onBlur={handleBlur}
        isInvalid={!!(touched.fullWidthOther && errors.fullWidthOther)}
        disabled={!isSettingWritable}
      />
      <br />
      <Row>
        <Col>
          <Button
            type='submit'
            disabled={!isSettingWritable || !isValid || Object.keys(touched).length === 0}
            size='sm'
          >
            更新
          </Button>
        </Col>
      </Row>
    </Form>
  )
}

export const MarginOutputSettingForm = Object.assign(_MarginOutputSettingForm, {
  schema: Yup.object().shape({
    fullWidthYear: Yup.boolean().required(),
    fullWidthMonth: Yup.boolean().required(),
    fullWidthDay: Yup.boolean().required(),
    fullWidthWareki: Yup.boolean().required(),
    fullWidthIssue: Yup.boolean().required(),
    fullWidthRevision: Yup.boolean().required(),
    fullWidthOther: Yup.boolean().required()
  })
})
